<template>
    <div class="chat-header">
        <slot />
    </div>
</template>

<style scoped lang="scss">
    .chat-header {
        display: flex;
        padding: 1rem;
        gap: 1rem;
        align-items: center;
    }

    .app--flat {
        .chat-header {
            background-color: var(--color-widget);
            color: var(--color-widget-text);
        }
    }
</style>
